import pageLoading from './Loading.vue'
const Loading = {
   install: function(Vue) {
      Vue.component('pageLoading', pageLoading)
   }
}
export default Loading